import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { CustomButton, GroupView } from '../../../artboard/Toolbar/styles';
import { TEXT_AREA_TOOLBAR } from '../../../artboard/Toolbar/translationValues';
import { ListIcon } from '../../../images/TextBlockIcons';
import styled from 'styled-components';

const GroupViewStyle = styled(GroupView)`
  .ql-picker-label[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }

  .ql-list {
    .ql-stroke {
      fill: none !important;
      stroke: #444 !important;
    }

    .ql-fill {
      fill: #444 !important;
    }
  }

  .ql-indent {
    .ql-stroke {
      fill: none !important;
      stroke: #444 !important;
    }

    .ql-fill {
      fill: #444 !important;
    }
  }

  .ql-formats.ql-custom-tray .ql-list.custom-picker .ql-stroke {
    stroke: #444 !important;
  }
`;

export const RenderBullets = ({ t, itemUUID }) => {
  const [showBullets, setShowBullet] = useState(false);

  const toggleBullets = value => {
    setShowBullet(value);
  };

  const checkClicks = (e, selector, callback) => {
    let targetElement = e.target;
    do {
      if (targetElement === selector) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
    callback();
  };

  const handleClicks = e => {
    const lineHeightSelector = document.querySelector(`#toolbar-${itemUUID} #spacing-ref`);

    checkClicks(e, lineHeightSelector, () => {
      if (showBullets) toggleBullets(false);
    });
  };

  useEffect(() => {
    document.addEventListener('click', handleClicks);
    return () => {
      document.removeEventListener('click', handleClicks);
    };
    // eslint-disable-next-line
  }, [showBullets]);

  return (
    <span style={{ position: 'relative' }}>
      <Tooltip
        placement="top"
        title={t(
          TEXT_AREA_TOOLBAR.TEXT_LIST_TOOLTIP.key,
          TEXT_AREA_TOOLBAR.TEXT_LIST_TOOLTIP.value,
        )}
      >
        <CustomButton
          className="custom-picker ql-format-style"
          onClick={() => toggleBullets(!showBullets)}
        >
          <ListIcon />
        </CustomButton>
      </Tooltip>

      <GroupViewStyle
        id="bullet-ref"
        style={{
          display: showBullets ? 'flex' : 'none',
          position: 'absolute',
          width: '150px',
          left: '50%',
          transform: 'translate(-50%, 0)',
        }}
      >
        <Tooltip
          placement="top"
          title={t(
            TEXT_AREA_TOOLBAR.TEXT_NUMBERED_LIST_TOOLTIP.key,
            TEXT_AREA_TOOLBAR.TEXT_NUMBERED_LIST_TOOLTIP.value,
          )}
        >
          <button className="ql-list custom-picker" value="ordered" />
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_AREA_TOOLBAR.TEXT_BULLETED_LIST_TOOLTIP.key,
            TEXT_AREA_TOOLBAR.TEXT_BULLETED_LIST_TOOLTIP.value,
          )}
        >
          <button className="ql-list custom-picker" value="bullet" />
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_AREA_TOOLBAR.TEXT_INDENT_MORE_TOOLTIP.key,
            TEXT_AREA_TOOLBAR.TEXT_INDENT_MORE_TOOLTIP.value,
          )}
        >
          <button className="ql-indent custom-picker" value="+1" />
        </Tooltip>
        <Tooltip
          placement="top"
          title={t(
            TEXT_AREA_TOOLBAR.TEXT_INDENT_LESS_TOOLTIP.key,
            TEXT_AREA_TOOLBAR.TEXT_INDENT_LESS_TOOLTIP.value,
          )}
        >
          <button className="ql-indent custom-picker" value="-1" />
        </Tooltip>
      </GroupViewStyle>
    </span>
  );
};
